import * as React from 'react';
import {connect} from 'react-redux';
import FormSelect, {FormSelectProps, MIN_WIDTH} from 'cl-form/FormSelect';
import * as _ from 'lodash';
import {StoreState} from '../../../../App/initialStore';
import {FormSelectOption} from 'cl-form/utils/orderByUtils';

export default connect(
  (state: StoreState, {minWidth}: Partial<FormSelectProps>) => {
    return {
      options: _.map(state.general.eBaySites, ({site, text}) => ({label: text, value: site} as FormSelectOption)),
      minWidth: minWidth || MIN_WIDTH.SMALL,
    } as Partial<FormSelectProps>;
  },
  {}
)(FormSelect);
